module.exports = __webpack_public_path__ + "images/f16fee49.pay_4_cht.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipintro/pay_4_cht.png
// module id = 544
// module chunks = 0